import {getBvFeatures, getBvGroupFeatures} from "./server-api";
import {getCurrentLayout} from "../bvcomponents/appLayout";
import {setAlreadyRequestedNames} from "../actions/filtersFunctions";
import store from "../store";
import Config from "../config";

let axiosController;

/**
 * renderErrorPopup can display retry connection and sign contract buttons
 * @param featureGroup {object}
 * @param searchText {string}
 * @param setShowLoader {function}
 */
export const searchProductRequest = async (featureGroup, searchText, setShowLoader = () => {}) => {
  if (!searchText || searchText.length < 2 || !featureGroup || featureGroup.getRealFeaturesReceivedProperty()
    || (Array.isArray(featureGroup.alreadyRequestedFeatureNames)
      && featureGroup.alreadyRequestedFeatureNames.some(alreadyRequestedText => {
        return alreadyRequestedText === searchText || searchText.includes(alreadyRequestedText) // arcilla red -> arcilla red suede
      }))
  ) {
    return false
  }
  setShowLoader(true);
  if (axiosController) {
    axiosController.abort();
  }
  if (AbortController) {
    axiosController = new AbortController();
  }
  const dbName = featureGroup.dbName || featureGroup.partName;
  const pageSize = 9999;
  if (document.kvConfig.visualizerType === "bvLook") {
    const layout = getCurrentLayout();
    const wallParent = layout.parts["Walls"];
    if (featureGroup.additionalPartPartId && wallParent && wallParent.relatedItems.some(relItem => relItem.partId === featureGroup.partId)) {
      const cropResponse = await getBvGroupFeatures(dbName + " Crop", 0, pageSize, [], searchText, null, axiosController);
      if (Array.isArray(cropResponse)) {
        featureGroup.setGroupFeatures(cropResponse, pageSize, false, "", null, true, false);
      }
    }
  }
  const response = await getBvGroupFeatures(dbName, 0, pageSize, [], searchText, null, axiosController)
  if (response) {
    featureGroup.setGroupFeatures(response, pageSize, false, "", null, true);
  }
  if (!featureGroup.alreadyRequestedFeatureNames) {
    featureGroup.alreadyRequestedFeatureNames = [];
  }
  featureGroup.alreadyRequestedFeatureNames.push(searchText);
  setShowLoader(false);
  return response ? response.data : []
}

/**
 * @param searchText {string}
 * @param setShowLoader {function}
 */
export const searchAllProductsRequest = async (searchText, setShowLoader) => {
  if (axiosController) {
    axiosController.abort();
  }
  if (!searchText || searchText.length < 3) {
    return Promise.resolve()
  }
  const {alreadyRequestedNames} = store.getState().filterState;
  if (alreadyRequestedNames.some(word => searchText.includes(word))) { // for example, we request Colo, but already had Col
    return Promise.resolve()
  }
  setShowLoader(true);
  if (AbortController) {
    axiosController = new AbortController();
  }
  const layout = getCurrentLayout();
  const response = await getBvFeatures(null, null, false, layout.visualizerType, searchText, axiosController)
  if (response && response.data) {
    if (Config.isDevMode()) {
      console.log("search response", response.data);
    }
    layout.loadNewFeatures(response.data);
  }

  store.dispatch(setAlreadyRequestedNames(searchText));

  setShowLoader(false);
  return response ? response.data : []
}
